import React, { useEffect, useState } from "react";
import DefaultLink from '../../../components/DefaultLink'
import Slider from "react-slick";
import { BaseUrl } from "../../../helper/BaseUrl";


var settings = {
  dots: true,
  slidesToShow: 4,
  autoplay: true,
  slidesToScroll: 1,
  pauseOnHover: false,
  arrows: false,
  cssEase: "linear",
  autoplaySpeed: 6000,
  speed: 2000,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 599,
      settings: {
        slidesToShow: 1,
      },
    },],
};

export default function SmallMidSized({ data, initialData }) {
  const [allData, setAllData] = useState(initialData || []);

  // API Calling
  const fetcher = async () => {
    try {
      const response = await fetch(`${BaseUrl}api/casestudies`, {
        method: 'GET',
      });
      const result = await response.json();
      if (result.casestudies === false) {
        throw new Error(`API error: ${result.message}`);
      }
      setAllData(result.casestudies);
    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };
  useEffect(() => {
    fetcher();
  }, [])

  if (!allData) {
    return <div style={{ height: "100vh", width: "100%" }}></div>;
  }

  return (
    <>
      <section className="small-midsized-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <div className="small-midsized-header">
                <h3 className="heading center-heading">{data?.head}</h3>
                <p className="sub-heading">{data?.desc}</p>
              </div>
            </div>
            <div className="col-lg-12">
              <Slider className="small-midsized-sliderbox" {...settings}>
                {allData?.map((item, index) => (
                  <div className="small-midsized-slider" key={index}>
                    <img src={`${BaseUrl}${item?.thumbnail}`} alt={item?.title} />
                    <span>{item?.title?.slice(0, 60) + "..."} </span>
                    <p>{item?.brief}</p>
                    {/* <DefaultLink text="Read This Case Study" to={`/case-study/${item?.slug}`} /> */}
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}